import { colorsTuple, DEFAULT_THEME, MantineColorsTuple } from "@mantine/core";
import { ExtendedCustomColors } from "@/app/theme/types/extended-colors";

export const colors: Record<ExtendedCustomColors, MantineColorsTuple> = {
  ...DEFAULT_THEME.colors,
  // Brand
  "brand-blue": colorsTuple("#5063C0"),
  "brand-purple": colorsTuple("#5C6ECA"),
  "brand-chambray": colorsTuple("#39498F"),
  "brand-hover": colorsTuple("#7D8BD5"),

  // Grey
  grey: colorsTuple("#A7A7A7"),
  "grey-semi": colorsTuple("#D8DBE2"),
  "grey-lightest": colorsTuple("#F0F2F5"),

  // White (with opacities — fallback to solid fallback)
  white: colorsTuple("#FFFFFF"),
  "white-80": colorsTuple("rgba(255, 255, 255, 0.8)"),
  "white-60": colorsTuple("rgba(255, 255, 255, 0.6)"),
  "white-40": colorsTuple("rgba(255, 255, 255, 0.4)"),

  // Black (with opacities)
  black: colorsTuple("#030C1C"),
  "black-80": colorsTuple("rgba(3, 12, 28, 0.8)"),
  "black-60": colorsTuple("rgba(3, 12, 28, 0.6)"),
  "black-40": colorsTuple("rgba(3, 12, 28, 0.4)"),
  "black-20": colorsTuple("rgba(3, 12, 28, 0.2)"),
  "black-10": colorsTuple("rgba(3, 12, 28, 0.1)"),
  "black-5": colorsTuple("rgba(3, 12, 28, 0.05)"),

  // Primary tints
  "primary-light": colorsTuple("#F7F9FB"),
  "primary-blue": colorsTuple("#E3F5FF"),
  "primary-purple": colorsTuple("#E5ECF6"),
  "primary-semi-purple": colorsTuple("rgba(229, 236, 246, 0.5)"),

  // Secondary
  "secondary-green-a": colorsTuple("#A1E3CB"),
  "secondary-green-b": colorsTuple("#BAEDBD"),
  "secondary-green-c": colorsTuple("#3FCA90"),
  "secondary-red": colorsTuple("#FF4747"),
  "secondary-red-b": colorsTuple("#FD7D7D"),
  "secondary-yellow-a": colorsTuple("#FFC555"),
  "secondary-yellow-b": colorsTuple("#FFE999"),
  "secondary-blue-a": colorsTuple("#A8C5DA"),
  "secondary-blue-b": colorsTuple("#E3F5FF"),
  "secondary-btn": colorsTuple("#4F68E8"),
  "secondary-pink": colorsTuple("#E84FE2"),
};
